import { MarkAsSolvedButton } from './MarkAsSolvedButton';
import withAskRequests from './withAskRequests';
import withQueue from './withQueue';

export const QueueMarkAsSolvedButton = withQueue(MarkAsSolvedButton);
export default withAskRequests(MarkAsSolvedButton);
